import {
    GET_DELIVERY_CONFIGURATION_SUCCESS,
    GET_DELIVERY_CONFIGURATION_FAIL,
    HIDE_NOTIFICATION,
    SET_DELIVERY_CONFIGURATION_SUCCESS,
    SET_DELIVERY_CONFIGURATION_FAIL,
    DELETE_DELIVERY_CONFIGURATION_SUCCESS,
    DELETE_DELIVERY_CONFIGURATION_FAIL
} from "./actionTypes";

const initialState = {
    dataDeliveryConfiguration: {
        deliveryConfiguration: undefined,
        success: {
            open: false,
            text: "",
        },
        error: {
            open: false,
            text: "",
        },
    }
};

const deliveryConfiguration = (state = initialState, action) => {
    switch (action.type) {
        case GET_DELIVERY_CONFIGURATION_SUCCESS:
            return {
                ...state,
                dataDeliveryConfiguration: {
                    ...state.dataDeliveryConfiguration,
                    deliveryConfiguration: action.payload,
                    success: {
                        open: true,
                        text: "Pomyślnie pobrano konfigurację dostawy.",
                    },
                }
            };

        case GET_DELIVERY_CONFIGURATION_FAIL:
            return {
                ...state,
                dataDeliveryConfiguration: {
                    ...state.dataDeliveryConfiguration,
                    error: {
                        open: true,
                        text: "Podczas pobierania kluczy konfiguracji dostawy wystąpił błąd, spróbuj ponownie.",
                    },
                },
            };

        case SET_DELIVERY_CONFIGURATION_SUCCESS:
            const oldConfigKeyIndex = state.dataDeliveryConfiguration.deliveryConfiguration.findIndex(item => item.key === action.payload.key);
            let updatedConfig = [];

            if (oldConfigKeyIndex !== -1) {
                const updatedConfigArray = [...state.dataDeliveryConfiguration.deliveryConfiguration];
                updatedConfigArray[oldConfigKeyIndex] = action.payload;
                updatedConfig = updatedConfigArray;
            } else {
                updatedConfig = [...state.dataDeliveryConfiguration.deliveryConfiguration, action.payload];
            }
            return {
                ...state,
                dataDeliveryConfiguration: {
                    ...state.dataDeliveryConfiguration,
                    deliveryConfiguration: updatedConfig,
                    success: {
                        open: true,
                        text: "Pomyślnie zaktualizowano klucz konfiguracji dostawy.",
                    },
                }
            };
        case SET_DELIVERY_CONFIGURATION_FAIL:
            return {
                ...state,
                dataDeliveryConfiguration: {
                    ...state.dataDeliveryConfiguration,
                    error: {
                        open: true,
                        text: "Podczas aktualizacji klucza konfiguracji dostawy wystąpił błąd, spróbuj ponownie.",
                    },
                },
            };
        case DELETE_DELIVERY_CONFIGURATION_SUCCESS:
            return {
                ...state,
                dataDeliveryConfiguration: {
                    ...state.dataDeliveryConfiguration,
                    deliveryConfiguration: state.dataDeliveryConfiguration.deliveryConfiguration.filter(item => item.key !== action.payload.key),
                    success: {
                        open: true,
                        text: "Pomyślnie usunięto klucz konfiguracji dostawy.",
                    },
                }
            };
        case DELETE_DELIVERY_CONFIGURATION_FAIL:
            console.log("DELETE_DELIVERY_FORMS_FAIL", action.payload);
            return {
                ...state,
                dataDeliveryConfiguration: {
                    ...state.dataDeliveryConfiguration,
                    error: {
                        open: true,
                        text: "Podczas usuwania klucza konfiguracji dostawy wystąpił błąd, spróbuj ponownie.",
                    },
                },
            };

        case HIDE_NOTIFICATION:
            return {
                ...state,
                dataDeliveryConfiguration: {
                    ...state.dataDeliveryConfiguration,
                    success: {
                        open: false,
                    },
                },
            };

        default:
            return state;
    }
};

export default deliveryConfiguration;
